const applicationErrorCopy = {
  INSUFFICIENT_STOCK: {
    title: 'No hay stock suficiente',
    explanation: 'El pedido se guardo, pero no pudimos descontar el stock de este producto porque no hay suficiente cantidad disponible.',
    nextStep: 'Actualiza el stock del producto y despues volve a intentarlo.',
  },
  STOCK_RECORD_MISSING: {
    title: 'Falta el stock del producto en el deposito',
    explanation: 'El producto esta vinculado, pero no existe un registro de stock utilizable para el.',
    nextStep: 'Asigna el producto a un deposito online y luego volve a intentar.',
  },
  WAREHOUSE_NOT_CONFIGURED: {
    title: 'No hay un deposito online disponible',
    explanation: 'MercuryCom no encontro un deposito activo y habilitado para ventas online.',
    nextStep: 'Revisa la configuracion de depositos y luego volve a intentar.',
  },
  LISTING_NOT_IMPORTED: {
    title: 'La publicacion no esta vinculada',
    explanation: 'El pedido se recibio correctamente, pero su publicacion todavia no esta importada en MercuryCom.',
    nextStep: 'Importa o vincula la publicacion y luego volve a intentar.',
  },
  LISTING_NOT_FOUND: {
    title: 'No encontramos la publicacion',
    explanation: 'El producto del pedido no coincide con una publicacion disponible en MercuryCom.',
    nextStep: 'Revisa la vinculacion del SKU y la publicacion antes de reintentar.',
  },
  PILOT_ITEM_DISABLED: {
    title: 'El producto no esta habilitado para sincronizar',
    explanation: 'El pedido se guardo, pero el producto esta fuera del alcance de sincronizacion configurado.',
    nextStep: 'Habilita el producto y luego volve a intentar.',
  },
  USER_SYNC_DISABLED: {
    title: 'La sincronizacion esta pausada',
    explanation: 'MercuryCom guardo el pedido pero no aplico movimientos mientras la sincronizacion estaba deshabilitada.',
    nextStep: 'Activa la sincronizacion antes de reintentar.',
  },
  APPLICATION_FAILED: {
    title: 'No pudimos confirmar la actualizacion del stock',
    explanation: 'El pedido se guardo, pero es posible que el stock de algunos productos ya se haya descontado.',
    nextStep: 'Revisa los movimientos de stock antes de hacer cambios o volver a procesar el pedido.',
  },
};

export const getApplicationErrorCopy = (code) => applicationErrorCopy[code] || {
  title: 'MercuryCom no pudo aplicar completamente el pedido',
  explanation: 'El pedido quedo guardado y auditado, pero uno o mas productos necesitan revision.',
  nextStep: 'Revisa el detalle de los productos antes de volver a intentar.',
};

export const hasOrderApplicationIssue = (order) => (
  order?.applicationStatus === 'BLOCKED' || order?.applicationStatus === 'PARTIALLY_APPLIED'
);

export const canRetryOrderApplication = (order) => (
  order?.applicationStatus === 'BLOCKED' && order?.retryDisposition === 'WAIT_FOR_CHANGE'
);
